import * as React from 'react';

export default function References() {
  return (
    <>
      <p className="text-sm leading-5 text-left text-gray-500">
        <a href="https://doi.org/10.1094/PDIS-10-23-2114-RE">Scott D. Cosseboom and Mengjun Hu 2024. Utilizing Disease Prediction Models to Time Fungicide Applications for Controlling Ripe Rot, Caused by Colletotrichum spp., in Maryland Vineyards. Plant Disease
        108:1526-1532</a>
      </p>
      <p className="text-sm leading-5 text-left text-gray-500">
        <a href="https://doi.org/10.1094/PHYTOFR-05-22-0060-R">Scott D. Cosseboom and Mengjun Hu 2023. Predicting Ripe Rot of Grape, Caused by Colletotrichum fioriniae, with Leaf Wetness, Temperature, and the Crop Growth Stage. PhytoFrontiers
          3:303-313</a>
      </p>
      <p className="text-sm leading-5 text-left text-gray-500">
        <a href="https://doi.org/10.1094/PHYTO-01-22-0004-R">Scott D. Cosseboom and Mengjun Hu 2022. Ontogenic Susceptibility of Grapevine Clusters to Ripe Rot, Caused by the Colletotrichum acutatum and C. gloeosporioides Species Complexes. Pytopathology
          112:1956-1964</a>
      </p>
    </>
  )
}


